// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3523":"c7ea6e75d142ae33","4438":"72b48b15783ae6f5","6735":"e141026dee1f454f"}[chunkId] + ".js";
};